import axios from "axios";
const api = axios.create({
    baseURL: process.env.REACT_APP_URL_API_CENSO,

});

api.interceptors.request.use((config) => {
    // Busca o token do sessionStorage toda vez que uma requisição é feita
    const aux = JSON.parse(sessionStorage.getItem("censo"));
    if (aux) {
        config.headers.Authorization = aux.token;
    }
    return config;
});

api.interceptors.response.use(function (response) {
    return response
}, function (error) {

    console.log('Erro na requisição:', error.response && (Number(error.response.status) === 403));
    if (error.response && (Number(error.response.status) === 403)) {
        sessionStorage.removeItem('censo')
        window.location.href = '/login'
    }

    return Promise.reject(error)
})

export default api